import { useBranding } from '@Contexts/branding';
import { Logo, type LogoProps } from '@synqo/frontend-component-library';

// @ai-generated 2026-10-09T14:35:50+00:00 by niklas.eicker@tngtech.com using Claude Opus 5.5 (1M context)
/** The current mandant's logo, or the Synqony logo. */
export function BrandLogo(props: Omit<LogoProps, 'url'>) {
    const { logoUrl } = useBranding();
    return <Logo url={logoUrl} {...props} />;
}
